export default __webpack_public_path__ + "static/media/showcase.bed41262.jpeg";